import AnimatedSection from '../../../components/base/AnimatedSection';

const canDo = [
  'Release on Spotify, Apple Music, Tidal, and all major platforms',
  'Sell unlimited physical copies — CDs, vinyl, USB drives',
  'Create official music videos for YouTube and social media',
  'Perform live at any event, venue, or festival worldwide',
  'Include on commercial albums, EPs, and mixtapes',
  'License to TV shows, films, and advertising (sync)',
  'Register with ASCAP, BMI, or SESAC to collect royalties',
  'Monetize fully on YouTube Content ID',
  'Sign a record label deal using this beat',
  'Distribute through any major distribution service',
];

const cannotDo = [
  'Resell or transfer the license to another artist',
  'Claim 100% songwriting royalties (5% retained by producer)',
  'Use the beat before purchase payment is fully confirmed',
  'Sub-license the instrumental to other artists without written consent',
  'Claim sole production credit — NCMG retains producer credit',
  'Use the beat for hate speech, defamatory, or illegal content',
];

export default function CanCannot() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-up" className="text-center mb-16">
          <div className="inline-block px-4 py-2 border border-gray-300 rounded-full text-xs font-semibold text-gray-700 mb-4 tracking-widest uppercase">
            Rights Breakdown
          </div>
          <h2 className="text-6xl font-bold text-gray-900 mb-4 leading-tight">
            What You Can &amp;<br />Cannot Do
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Clear. No legal jargon. Just the facts.
          </p>
        </AnimatedSection>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* CAN DO */}
          <AnimatedSection animation="slide-left" delay={150} className="bg-gray-50 rounded-3xl p-10 border border-gray-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full">
                <i className="ri-check-line text-lg text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">You CAN do this</h3>
            </div>
            <ul className="space-y-4">
              {canDo.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-gray-800 text-base"></i>
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </AnimatedSection>

          {/* CANNOT DO */}
          <AnimatedSection animation="slide-right" delay={250} className="bg-gray-900 rounded-3xl p-10">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full">
                <i className="ri-close-line text-lg text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white">You CANNOT do this</h3>
            </div>
            <ul className="space-y-4">
              {cannotDo.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-circle-fill text-gray-500 text-base"></i>
                  </div>
                  <span className="text-gray-400 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>

            {/* Royalty note */}
            <div className="mt-8 pt-8 border-t border-white/10">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-amber-400 text-base"></i>
                </div>
                <p className="text-gray-400 text-xs leading-relaxed">
                  The 5% producer royalty is standard industry practice and only applies to performance/mechanical royalties collected through a PRO (ASCAP, BMI, SESAC). You keep <strong className="text-white">95% of all earnings</strong>.
                </p>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
